import { UiDivider } from '@experiences/ui-common/UiDivider';
import { UiSignupLayout } from '@experiences/ui-common/UiSignupLayout';
import {
    Link,
    Typography,
} from '@mui/material';
import {
    createStyles,
    makeStyles,
} from '@mui/styles';
import clsx from 'clsx';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import BottomPageOptions from '../../common/UiBackground/subcomponents/BottomPageOptions';
import UiProviderButton from '../../common/UiProviderButton/UiProviderButton';
import { SimpleSignupFormComponent } from '../../common/UiSignup';
import useLogin from '../../util/hooks/Login';
import Providers from '../../util/interfaces/provider';

const useStyles = makeStyles(theme =>
    createStyles({
        container: {
            display: 'flex',
            overflow: 'auto',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
        },
        flex: {
            display: 'flex',
            flexDirection: 'column',
        },
        title: {
            color: theme.palette.common.black,
            fontFamily: 'Poppins',
            fontWeight: 600,
            fontSize: '32px',
            textAlign: 'center',
        },
        standardMargin: {
            marginTop: '16px',
            textAlign: 'center',
        },
        form: { paddingTop: 'max(15vh, 40px)' },
        standardWidth: { width: '400px' },
        spacer: { margin: '32px 0' },
        spacerXL: { margin: '48px 0' },
    }),
);

export default function SignupPageComponentRevamp() {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();
    const navigateToLogin = useLogin();

    const [ collapseCondition, setCollapseCondition ] = useState(false);

    return (
        <UiSignupLayout>
            <div className={clsx(classes.container)}>
                <div className={clsx(classes.standardWidth, classes.form)}>
                    <Typography className={clsx(classes.title)}>
                        {translate({ id: 'OFFERS_REVAMP_HEADER' })}
                    </Typography>
                    <Typography className={classes.standardMargin}>
                        {translate(
                            { id: 'ACCOUNT_ALREADY_EXISTS_SKU' },
                            {
                                SIGNIN: (
                                    <Link
                                        onClick={() => {
                                            navigateToLogin();
                                        }}
                                        data-cy="signup-goto-login"
                                        tabIndex={0}
                                        style={{ cursor: 'pointer' }}
                                        underline="none"
                                    >
                                        {translate({ id: 'SIGN_IN' })}
                                    </Link>
                                ),
                            },
                        )}
                    </Typography>
                    <div className={classes.spacerXL} />
                    <SimpleSignupFormComponent
                        collapseProps={{
                            collapseCondition,
                            setCollapseCondition,
                        }}
                        isRevamp
                    />
                    <div className={classes.flex}>
                        <UiDivider className={clsx(classes.standardWidth, classes.spacerXL)} />
                        <UiProviderButton
                            provider={Providers.Google}
                            showOptions={false}
                            centered />
                        <UiProviderButton
                            provider={Providers.Microsoft}
                            showOptions={false}
                            centered />
                    </div>
                    <div className={classes.spacer} />
                </div>
                <BottomPageOptions languageSelectorOnly />
            </div>

        </UiSignupLayout>
    );
}

